import React from 'react';
import {Tag} from 'antd';
import VStack from './Layout/VStack';
import HStack from './Layout/HStack';
import AppText from './AppText';
import CustomButtonV2 from './CustomButtonV2';
import {t} from '../../services/i18n';
import {Colors} from '../../styles/Colors';

const FILTER_TAG_BG = '#f0f0f0';
const FILTER_TAG_HOVER_BG = Colors.newDesign.avatarBgColor;
const FILTER_TAG_SELECTED_HOVER_BG = '#C8E8FA';

const getFilterTagBackgroundColor = (isSelected, isHovered) => {
    if (isSelected) {
        return isHovered ? FILTER_TAG_SELECTED_HOVER_BG : Colors.newDesign.lightBlueBackground;
    }
    return isHovered ? FILTER_TAG_HOVER_BG : FILTER_TAG_BG;
};

const filterTagStyle = (isSelected, isHovered) => ({
    cursor: 'pointer',
    border: 'none',
    borderRadius: '999px',
    padding: '6px 16px',
    fontSize: '14px',
    lineHeight: '20px',
    marginInlineEnd: 0,
    backgroundColor: getFilterTagBackgroundColor(isSelected, isHovered),
    color: Colors.newDesign.mainText,
});

const FilterTags = ({labelKey, options, selectedIds, onTagClick}) => {
    if (!options.length) {
        return null;
    }

    return (
        <VStack space={'0.5rem'}>
            <AppText fontSize={'12px'} mediumFont color={Colors.newDesign.mainText} style={{letterSpacing: '0.3px'}}>
                {t(labelKey)}
            </AppText>
            <HStack space={'0.5rem'} flexWrap={'wrap'} style={{rowGap: '0.5rem'}}>
                {options.map(option => (
                        <CustomButtonV2
                        key={option.id}
                        onClick={() => onTagClick(option.id)}
                        override={({isHovered}) => (
                            <Tag style={filterTagStyle(selectedIds.includes(option.id), isHovered)}>
                                {option.name}
                            </Tag>
                        )}
                    />
                ))}
            </HStack>
        </VStack>
    );
};

export default FilterTags;
